import CountMeasureFieldDto from './CountMeasureFieldDto';

export default class CountMeasureDto {
  constructor(options = {}) {
    this.id = options.id || 0;
    this.name = options.name || '';
    this.measureType = options.measureType || '';
    this.fieldValues = options.fieldValues ? options.fieldValues.map(dto => new CountMeasureFieldDto(dto)) : [];
  }
}